export default __webpack_public_path__ + "static/media/hugoSaba.94128264.png";